import React from 'react'

import LandingPromotionsContainer from '../components/promotions/LandingPromotionsContainer'

const LandingPromotionsScreen = props => <LandingPromotionsContainer {...props} />

export default LandingPromotionsScreen
